"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Illustration.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Illustration(_ref) {
  var name = _ref.name,
      margin = _ref.margin,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["name", "margin", "className"]);

  var cssClasses = ['st_illustration'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_react["default"].createElement("img", _extends({}, otherProps, {
    alt: name,
    className: cssClasses.join(' '),
    src: "https://screentone.djnews.tools/assets/" + name + ".svg"
  }));
}

Illustration.propTypes = {
  /** Name of the illustration to be displayed */
  name: _propTypes["default"].oneOf(['404', 'analysis', 'app-manager', 'authoring', 'bce', 'blank', 'bug', 'carousel-editor', 'chartlos', 'collect', 'conference', 'content-creator', 'control-panel', 'curation', 'developer', 'empty', 'error', 'finish-line', 'gams', 'high-five', 'image-manager', 'in-todays-paper', 'live-coverage', 'methode', 'news-alerts', 'newsgrid', 'newsroom-links', 'no-access', 'no-data', 'no-notifications', 'no-schedule', 'notes', 'pubcrawl', 'secure-data', 'server-down', 'status-update', 'typewriter', 'upload', 'walking', 'warning', 'webpage', 'weekly-advisor']).isRequired,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** margin for component, if any */
  margin: utils.spacing.marginProps
};
Illustration.defaultProps = {
  className: null,
  margin: null
};
var _default = Illustration;
exports["default"] = _default;